import { flattenI18nData } from "../i18n";
import { BRAND_NAME } from "../../brand";

const selfName = "简体中文 (中国)"
const appName = BRAND_NAME
export default flattenI18nData({
	"i18n.self_name": selfName,

	"title": {
		"default": appName,
		"new": appName,
		"newDirty": "● " + appName,
	},

	// 这里原本还有一整块 preview.heading#html.*：上游开源版「试用模式」欢迎页横幅的
	// 文案（不支持文件保存 / 建议下载桌面版 / Ctrl+S 快捷键提示）。TestApp 里那段
	// importantWarning 已删，这些 key 再没人消费，一并清掉。

	// 导出完成
	"export_finish": "音频数据导出完成，请复制下面地址访问。\n链接将在 2 分钟内失效。"
})
